export const aboutImages = {
  team: 'https://cdn.magicpatterns.com/uploads/v1aKdVwCWuoJuFniMukF5s/Pics_196-1.webp',
  founders: 'https://cdn.magicpatterns.com/uploads/uAbhQAvQ3KMUrJQno8VZEp/Untitled-design-40.webp',
  staff: 'https://cdn.magicpatterns.com/uploads/aR3iHzn9vTZ4PLAN4pXYJw/Untitled-design-51.webp',
};

export const aboutMission = 'Empowering individuals through high-quality education and cultural immersion experiences.';

export const aboutStory: string[] = [
  'Founded in 2016 by siblings Montserrat Taylor and Daniel Rodriguez from Bogotá, ES World began with a bold vision to make Dubai a premier destination for English language learning.',
  'From just three students and a handful of classrooms, we have grown into a global education group welcoming thousands of students annually from 106+ nationalities, with campuses in Dubai and London and summer camps in cities across four continents.',
];

export const companyValues: { title: string; text: string }[] = [
  { title: 'Big thinkers', text: "We dare to think big, embrace our entrepreneurial spirit, and take smart risks. Let's go big or go home as we pioneer new paths and make a meaningful impact!" },
  { title: 'Dynamic & fun', text: 'Work should be enjoyable! We are energetic and our workplace reflects our vibrant team.' },
  { title: 'Quality champions', text: 'We chase quality in everything we create, setting our sights high to deliver services, systems, and facilities that we can all be proud of.' },
  { title: 'Technology driven', text: 'We embrace technology and stay at the forefront of new innovations and tools, to the benefit of both our staff and our customers.' },
  { title: 'Women empowerment champions', text: 'We embrace and uplift women in our workplace. We celebrate their contributions and empower every woman to thrive and lead.' },
  { title: 'Supportive and flexible', text: "We are always happy to help! Our team is eager to help and accommodate everyone's needs whenever possible. We foster a caring and understanding environment." },
  { title: 'Innovative adventurers', text: "We're always exploring new ideas, pushing boundaries, and embracing a curious mindset." },
  { title: 'Celebrate diversity', text: 'We believe that multiculturality, inclusivity and diversity lead to better ideas and greater creativity. Our unique perspectives strengthen us, fostering an inclusive space where innovation flourishes.' },
  { title: 'Customer obsessed', text: 'We prioritise our customers and put them at the heart of everything we do!' },
];

export const initiativesIntro =
  'Beyond the classroom, we invest in the people and communities around us — from supporting children’s education through ES Helps to building a team where talented educators can grow their careers.';

export const initiatives: { title: string; text: string; cta: string; to: string; tone: 'green' | 'black'; image: string; alt: string }[] = [
  {
    title: 'ES Helps',
    text: 'Our community programme bringing learning and opportunity to children who need it most.',
    cta: 'Learn More',
    to: '/about/es-helps',
    tone: 'green',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7f00b459-5be6-44a7-8f18-1692e0bac487.jpg',
    alt: 'A group of smiling children standing together outdoors',
  },
  {
    title: 'Careers',
    text: 'Join a dynamic, multicultural team shaping the future of language education.',
    cta: 'Open roles',
    to: '/about/careers',
    tone: 'black',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6c8dc2c1-b53f-4c1c-ab5d-7e4cf19ed256.jpg',
    alt: 'Students and staff walking through a bright, modern school corridor',
  },
];

export const philosophyIntro =
  'What started with just three students and one small classroom has become a global phenomenon. We blend high-quality instruction with practical skill-building to help students grow academically, professionally, and personally.';

export const philosophyPillars: { id: 'language' | 'career' | 'academic' | 'global'; title: string; text: string }[] = [
  { id: 'language', title: 'Language Proficiency', text: 'Through engaging courses in General English, Business English, IELTS, and more.' },
  { id: 'career', title: 'Career-Ready Skills', text: 'Digital marketing, entrepreneurship, and vocational training that lead to real-world opportunities.' },
  { id: 'academic', title: 'Academic Pathways', text: 'Our Valmore College programmes to support students moving into higher education.' },
  { id: 'global', title: 'Global Readiness', text: 'A multicultural classroom environment prepares students to thrive anywhere in the world.' },
];
